import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start !important;
  justify-content: flex-end;
  position: relative;
`;

export const StatusTag = styled.div<{ $color: string; $statusSize?: number }>`
  width: ${({ $statusSize }) => `${$statusSize}px`};
  height: ${({ $statusSize }) => `${$statusSize}px`};
  border-radius: 50%;
  border: 2px solid white;
  background-color: ${({ $color }) => $color};
  position: absolute;
`;
